import { render } from "./overtime-modal.vue?vue&type=template&id=a2975e96"
import script from "./overtime-modal.vue?vue&type=script&lang=js"
export * from "./overtime-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__